import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import customInput from '../app-form/field/customInput'
import Spinner from '../spinner'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'

class ChangebleCostDialog extends Component {
  state = {
    showLoading: false,
  }
  handleSubmitForm = event => {
    const json = response => {
      return response.json()
    }

    event.preventDefault()
    const data = new FormData(event.target)

    this.setState({ showLoading: true })

    fetch('/statistics/' + this.props.rowId + '/update', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify({
        cost: data.get('cost'),
      }),
    })
      .then(status)
      .then(json)
      .then(({ status, message, row }) => {
        this.setState({ showLoading: false })
        this.props.onUpdate(row)
        this.props.onClose()
      })
      .catch(error => {
        console.log('Request failed', error)
        this.setState({ showLoading: false })
      })
  }

  render() {
    return (
      <Dialog
        open={this.props.show}
        onClose={this.props.onClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={this.handleSubmitForm}>
          <DialogContent>
            <Field
              name="cost"
              component={customInput}
              type="text"
              label="Введите расходы"
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                flexShrink: 0,
                fontSize: 16,
                height: 48,
                paddingTop: 0,
                paddingBottom: 0,
              }}
              onClick={this.props.onClose}
            >
              Отмена
            </Button>
            <Button
              style={{
                flexShrink: 0,
                fontSize: 16,
                minWidth: 125,
                height: 48,
                paddingTop: 0,
                paddingBottom: 0,
              }}
              type="submit"
              variant="contained"
              color="secondary"
            >
              {!this.state.showLoading ? 'Сохранить' : <Spinner />}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

ChangebleCostDialog = reduxForm({
  form: 'cost',
  enableReinitialize: true,
})(ChangebleCostDialog)

export default ChangebleCostDialog
